import api from "@/lib/api";
import { toast } from "sonner";
import { useEffect, useState } from "react";

let vatCache = null;
export function useVat() {
  const [vat, setVat] = useState(vatCache ?? 19);
  useEffect(() => {
    if (vatCache !== null) return;
    api.get("/settings").then((r) => { vatCache = Number(r.data.vat_rate ?? 19); setVat(vatCache); }).catch(() => {});
  }, []);
  return vat;
}

export const eur = (v) => Number(v || 0).toLocaleString("de-DE", { style: "currency", currency: "EUR" });
export const vatHint = (vat) => `netto zzgl. ${String(vat).replace(".", ",")} % MwSt.`;

export async function downloadBlob(url, params, filename) {
  try {
    const r = await api.get(url, { params, responseType: "blob" });
    const href = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = href; a.download = filename; a.click();
    URL.revokeObjectURL(href);
  } catch { toast.error("Download fehlgeschlagen"); }
}

const RED = "bg-red-600 text-white border-red-600";
const AMBER = "bg-amber-500 text-white border-amber-500";
const GREEN = "bg-emerald-600 text-white border-emerald-600";
const SLATE = "bg-slate-500 text-white border-slate-500";

export const WORKFLOW = {
  partner: {
    path: "/partner/anzeigen", detailPath: "/partner", area: "partner",
    title: "Anzeigen-Workflow", sub: "Freianzeigen der aktiven Partner – Druckunterlagen (DU) je Ausgabe im Blick.",
    adLabel: "Freianzeige", statusLabel: "Druckunterlagen", empty: "Keine Partner in dieser Ansicht.", one: "Partner",
    statuses: [["offen", "DU offen", RED], ["angefragt", "DU angefragt", AMBER], ["geliefert", "DU geliefert", GREEN]],
    articleOn: "geliefert", pdfName: "Anzeigen-Workflow",
  },
  bezahlkunde: {
    path: "/anzeigenkunden/anfragen", detailPath: "/anzeigenkunden", area: "bezahlkunden",
    title: "Anzeigen-Anfragen", sub: "Eingegangene Buchungen der Anzeigenkunden prüfen, zusagen oder absagen.",
    adLabel: "Gebuchte Anzeige", statusLabel: "Buchung", empty: "Keine Buchungen in dieser Ansicht.", one: "Anzeigenkunde",
    statuses: [["eingegangen", "eingegangen", AMBER], ["zugesagt", "zugesagt", GREEN], ["abgesagt", "abgesagt", RED]],
    extra: [["offen", "nicht angefragt", SLATE], ["angefragt", "angefragt", "bg-sky-500 text-white border-sky-500"]],
    filters: [["aktiv", "Eingegangen + zugesagt", ["eingegangen", "zugesagt"]]], defaultFilter: "aktiv",
    articleOn: "zugesagt", pdfName: "Anzeigen-Anfragen",
  },
};

export const statusMap = (type) => Object.fromEntries([...(WORKFLOW[type].extra || []), ...WORKFLOW[type].statuses].map(([k, l, c]) => [k, [l, c]]));
